var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOlansIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 13.3333H9.52318M6.66602 9.16667H13.3327",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 2.91667H15.416C16.3365 2.91667 17.0827 3.66286 17.0827 4.58334V16.6667C17.0827 17.5872 16.3365 18.3333 15.416 18.3333H4.58268C3.66221 18.3333 2.91602 17.5872 2.91602 16.6667V4.58334C2.91602 3.66286 3.66221 2.91667 4.58268 2.91667H6.66602",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0827 1.66667H7.91602C7.22566 1.66667 6.66602 2.22631 6.66602 2.91667C6.66602 3.60703 7.22566 4.16667 7.91602 4.16667H12.0827C12.773 4.16667 13.3327 3.60703 13.3327 2.91667C13.3327 2.22631 12.773 1.66667 12.0827 1.66667Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlansIcons);
export default __webpack_public_path__ + "static/media/olans-icons.aad697b39444f58a5ba926757c7b8519.svg";
export { ForwardRef as ReactComponent };